module.exports = __webpack_public_path__ + "img/logo-only-dark.b03b1ea8.png";